/** Provider component for TaskUIContext. */
// @ts-check
import { TaskUIContext } from './TaskUIContextDef.js';

/**
 * @param {{ children: import('react').ReactNode, value: object }} props
 */
export const TaskUIProvider = ({ children, value }) => {
  return (
    <TaskUIContext.Provider value={value}>{children}</TaskUIContext.Provider>
  );
};
